import { create } from "zustand";

import type { SEmbedSection } from "./useSEmbed";

type NavigationMemoryState = {
  paths: Partial<Record<SEmbedSection, string>>;
  setPath: (section: SEmbedSection, path: string) => void;
};

export const useSEmbedNavigationMemoryStore = create<NavigationMemoryState>((set) => ({
  paths: {},
  setPath: (section, path) =>
    set((state) => ({
      paths: { ...state.paths, [section]: path },
    })),
}));
